import axios from 'axios'
import { EEnv } from 'src/constants'

export const axiosHiringApi = axios.create({
  baseURL: EEnv.REACT_APP_HIRING_API_DNS,
  withCredentials: true
})
